import { JobRequest } from "./job-request";
import { PlanDataRequest } from "./plan-data-request";
export class PlanWithJobRequest {
    id?: string;
    planContainerId!: string;
    organizationUnitId!: string;
    connectionId!: string;
    planData!: PlanDataRequest
    jobRequestDtos!: JobRequest;
}